// extracted by mini-css-extract-plugin
module.exports = {"errorText":"DataVerification_errorText__qadqJ","pendingMessage":"DataVerification_pendingMessage__7_-Z7","container":"DataVerification_container__3GivH"};